import { useEffect, useRef } from "react";
import { realtimeClient, getRealtimeSessionId, type RealtimeEventPayload } from "@/lib/realtimeClient";
import { useProjectOverview } from "@/projectOverview/useProjectOverview";

/**
 * Öffnet die Projektübersicht, wenn ein anderes Gerät den Deckblatt-QR gescannt hat.
 */
export function useProjectOpenRealtime() {
  const { open } = useProjectOverview();
  const openRef = useRef(open);
  openRef.current = open;

  useEffect(() => {
    return realtimeClient.addListener({
      events: ["project_open_requested"],
      onChange: (payload?: RealtimeEventPayload) => {
        const data = payload?.data;
        if (!data || typeof data !== "object") return;

        const sourceSessionId = String(data.source_session_id || "").trim();
        const ownSessionId = getRealtimeSessionId();
        if (sourceSessionId && ownSessionId && sourceSessionId === ownSessionId) {
          return;
        }

        const auftragId = Number(data.auftrag_id);
        if (!Number.isFinite(auftragId) || auftragId <= 0) return;
        openRef.current(auftragId);
      },
    });
  }, []);
}
